module.exports = __webpack_public_path__ + "img/image6@2x.90d039aa.png";